<template>
  <v-container fluid>
    <!-- <v-card> -->
      <v-card-title>
        <v-icon class="me-2">mdi-message</v-icon>
        Messages
      </v-card-title>
      <v-card-subtitle>Manage your incoming messages here</v-card-subtitle>
      <v-data-table
        :headers="headers"
        :items="messages"
        :sort-by="sortBy"
        :sort-desc="sortDesc"
        class="elevation-1"
        item-key="id"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
      >
        <template v-slot:item.is_read="{ item }">
          <!-- Use v-chip to display 'READ' or 'NOT READ' with color -->
          <v-chip
            :color="item.is_read ? 'success' : 'warning'"
            text-color="white"
            small
          >
            {{ item.is_read ? 'READ' : 'NOT READ' }}
          </v-chip>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn
            prepend-icon="mdi-eye"
            color="primary"
            size="small"
            @click="viewMessage(item)"
            class="mx-1"
          >
            View
          </v-btn>
          <v-btn
            prepend-icon="mdi-delete"
            color="error"
            size="small"
            @click="openDeleteDialog(item)"
            class="mx-1"
          >
            Delete
          </v-btn>
        </template>
      </v-data-table>

      <!-- Message Details Dialog -->
      <v-dialog v-model="dialog" max-width="600px">
        <v-card>
          <v-card-title class="d-flex justify-space-between align-center">
            <div class="text-h5 text-medium-emphasis ps-2">
              Message Details
            </div>
            <v-btn
              icon="mdi-close"
              variant="text"
              @click="dialog = false"
            ></v-btn>
          </v-card-title>
          <v-divider class="mb-4"></v-divider>
          <v-card-text>
            <div><strong>Name:</strong> {{ selectedMessage.name }}</div>
            <div><strong>Subject:</strong> {{ selectedMessage.subject }}</div>
            <div><strong>Email:</strong> {{ selectedMessage.email }}</div>
            <div><strong>Phone:</strong> {{ selectedMessage.phone_number }}</div>
            <div><strong>Message:</strong></div>
            <div style="white-space: pre-line;"> {{ selectedMessage.message }}</div>
            <div><strong>Received on:</strong> {{ formatDate(selectedMessage.created_at) }}</div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="warning"
              @click="toggleReadStatus(selectedMessage)"
            >
              {{ selectedMessage.is_read ? 'Mark as Unread' : 'Mark as Read' }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Delete Confirmation Dialog -->
<v-dialog v-model="deleteDialog" max-width="400px">
  <v-card>
    <v-card-title class="headline">Delete Confirmation</v-card-title>
    <v-card-text>Are you sure you want to delete this message?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn 
        color="primary" 
        variant="flat" 
        size="small" 
        prepend-icon="mdi-close" 
        @click="deleteDialog = false"
      >
        Cancel
      </v-btn>
      <v-btn 
        color="error" 
        variant="flat" 
        size="small" 
        prepend-icon="mdi-delete" 
        @click="confirmDelete"
      >
        Delete
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

    <!-- </v-card> -->
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      headers: [
        { title: "Name", key: "name" },
        { title: "Subject", key: "subject" },
        { title: "Email", key: "email" },
        { title: "Phone", key: "phone_number" },
        { title: "Received", key: "created_at" },
        { title: "Status", key: "is_read", sortable: false },  // Added 'Status' header
        { title: "Actions", key: "actions", sortable: false }
      ],
      messages: [],
      sortBy: ['created_at'],
      sortDesc: [true],
      dialog: false,
      deleteDialog: false,
      selectedMessage: {},
      messageToDelete: '',
    };
  },
  mounted() {
    this.fetchMessages();
  },
  methods: {
    async fetchMessages() {
      try {
        const response = await this.$axios.get("/messages", {
          headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') }
        });
        this.messages = response.data.data;
      } catch (error) {
        console.error("Error fetching messages:", error);
      }
    },
    viewMessage(message) {
      this.selectedMessage = message;
      this.dialog = true;
    },
    async toggleReadStatus(message) {
      try {
        const updatedStatus = !message.is_read;
        await this.$axios.put(`/messages/${message.message_id}/mark-read`, { is_read: updatedStatus }, {
          headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') }
        });

        // Update the is_read field in the local data to reflect the change
        message.is_read = updatedStatus;
      } catch (error) {
        console.error("Error toggling read status:", error);
      }
    },
    openDeleteDialog(message) {
      this.messageToDelete = message;
      this.deleteDialog = true;
    },
    async confirmDelete() {
      try {
        await this.$axios.delete(`/messages/${this.messageToDelete.id}`, {
          headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') }
        });
        this.deleteDialog = false;
        this.fetchMessages();
      } catch (error) {
        console.error("Error deleting message:", error);
      }
    },
    formatDate(date) {
      return new Date(date).toLocaleString();
    },
  },
};

</script>